import type { TranslationTree } from '../../types';

export const auth: TranslationTree = {
  auth: {
    loading: 'Laden…',
    hero: {
      badge: 'ToolLife-Anmeldung',
      title: 'Werkzeug-Lebenszyklusverwaltung',
      description:
        'Verwalten Sie Rückverfolgbarkeit, Analysen und die Werkzeug-Lebenszyklusüberwachung von Fräswerkzeugen auf einer einzigen Plattform.',
      tagline: 'Rückverfolgbarkeit · Analytik · Werkzeugüberwachung',
      promises: {
        traceability: {
          title: 'Sofortige Rückverfolgbarkeit',
          description:
            'Erfassen Sie Werkzeugvorgänge per QR-Scan oder manueller Eingabe und rufen Sie den Verlauf je Werkzeug ab.',
        },
        machineControl: {
          title: 'Analysen',
          description:
            'Zeigen Sie KPI-Diagramme an und vergleichen Sie mehrere Werkzeugreferenzen im Analyse-Dashboard.',
        },
        security: {
          title: 'Sicherheit unter Kontrolle',
          description: 'Verschlüsselte Verbindungen und rollenbasierte Zugriffskontrolle.',
        },
      },
    },
    login: {
      badge: 'Sicheres Portal',
      title: 'Bei ToolLife anmelden',
      description: 'Geben Sie Ihre Anmeldedaten ein, um auf die Plattform zuzugreifen.',
      fields: {
        email: {
          label: 'E-Mail-Adresse',
          placeholder: 'vorname.nachname@unternehmen.de',
        },
        password: {
          label: 'Passwort',
          placeholder: '••••••••',
          show: 'Passwort anzeigen',
          hide: 'Passwort verbergen',
        },
        remember: 'Auf diesem Gerät angemeldet bleiben',
      },
      button: {
        idle: 'Anmelden',
        submitting: 'Anmeldung läuft…',
      },
      errors: {
        unexpected: 'Es ist ein unerwarteter Fehler aufgetreten.',
      },
      footer: {
        notice: 'Melden Sie sich nur von einem vertrauenswürdigen Gerät aus an.',
      },
    },
    highlights: {
      security: {
        title: 'Sicherheit im Fokus',
        description: 'Verschlüsselte Anmeldung und rollenbasierte Zugriffsverwaltung.',
      },
      liveMonitoring: {
        title: 'Werkzeugübersicht',
        description:
          'Durchsuchen Sie die Werkzeugliste, prüfen Sie den RUL-Statusindikator und rufen Sie den vollständigen Verlauf ab.',
      },
      automation: {
        title: 'Rückverfolgbarkeitseingabe',
        description:
          'Erfassen Sie einen Vorgang per QR-Scan oder Formular mit Maschine, Werkstoff und Werkzeughalter.',
      },
      experience: {
        title: 'Mehrsprachige Oberfläche',
        description:
          'Die Oberfläche ist auf Englisch, Französisch und Deutsch verfügbar, wählbar direkt auf dem Anmeldebildschirm.',
      },
    },
    support: {
      title: 'Support',
      description:
        'Kontaktieren Sie uns bei Fragen zur Installation, zum Onboarding oder zur Sicherheit.',
      email: 'ing.toollife@he-arc.ch',
      instructions: 'Antworten Sie auf diese E-Mail und wir melden uns bei Ihnen.',
    },
    password: {
      requirements: {
        hint: 'Mindestens 8 Zeichen, ein Großbuchstabe, ein Kleinbuchstabe und eine Ziffer.',
      },
    },
  },
};
